import React from 'react';
import bem from 'utils/bem';
import Icon from 'components/Icon';

import './index.sass';

const { block, el, cnEl } = bem('feedback-widget');

const FeedbackWidget = ({onClick, disabled = onClick === undefined}) => {
    return (
        <div className={cnEl('mui-fixed', 'positioning' )}>
            <button className={block()} onClick={onClick} disabled={disabled}>
                <div className={el('animated-circle')} />
                <div className={el('hover-gradient')} />
                <div className={el('active-gradient')} />
                <Icon name={'message'} />
            </button>
        </div>
    )
}

export default FeedbackWidget;
